export { ReactComponent as IcoBJ } from './IcoBJ.svg';
export { ReactComponent as IcoBJBust } from './IcoBJBust.svg';
export { ReactComponent as IcoBJLose } from './IcoBJLose.svg';
export { ReactComponent as IcoBJPush } from './IcoBJPush.svg';
export { ReactComponent as IcoBJWin } from './IcoBJWin.svg';